

import React, { useState, useContext } from "react";
import ChatPanel from "./components/ChatPanel";
import Toast from "./components/Toast";
import { MyContext } from '../MyContext';
// import RecapModal from "./components/RecapModal"; // optional

import { fetchShiftSummary, fetchShiftSummaryRange, fetchCurrentShiftSummary } from "./services/api";
import { getShapeFromLLM, getNarrativeFromLLM } from "./services/llm";
import { compactSingle, compactMachineState, compactMultiSummaries } from "./logic/compact";
import { summarizeResponse, summarizeMachineStateRow, summarizeMachineStatusList } from "./logic/summarize";
import { parseQuestionToBody, wantsCurrentShift } from "./logic/parseQuestion";
import {
  isMoMProductionQuestion, getMonthRange, summarizeMoMResult,
  isWoWProductionQuestion, getWeekRange, summarizeWoWResult,
  aggregatePartsByMachine, computeMoMDeltas
} from "./logic/compare";
import { validateShape } from "./utils/validateShape";
import { getCurrentDateShiftString } from '../ContextDataFetcher'
export default function OperatorAssistantApp() {
  const { customerName, data } = useContext(MyContext)
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    { from: "assistant", text: "Hi! Ask me about utilization, parts, downtime, or comparisons." }
  ]);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);

  function pushAssistant(text) {
    setMessages(m => [...m, { from: "assistant", text }]);
  }
  function pushUser(text) {
    setMessages(m => [...m, { from: "user", text }]);
  }

  async function handleAsk(question) {
    //we need to know the archive path for the current downtime questions
    const downtimePath = getCurrentDateShiftString(data);
    console.log("archiveDowntime: " + downtimePath)
    if (!question || !question.trim()) return;
    pushUser(question);
    setLoading(true);

    try {


      // Branch 3: Downtime-oriented questions -> use LLM to shape payload (hybrid approach)
      const isDowntime = /downtime|unlabeled|unlabelled|no label/i.test(question);
      let mode = "general"
      //const base = parseQuestionToBody(customerName, question);
      //const siteId = customerName;
      let shape = null;
      let data = null;
      let answer
      if (isDowntime) {
        mode = "downtime"
      }
      // 1) Use rules to get solid dates/shifts

      // 2) Get shape from LLM (intent)

      try {
        shape = await getShapeFromLLM(question);
        const { valid, error, shape: safeShape } = validateShape(shape);
        if (!valid) {
          console.warn("Invalid shape:", error, shape);
          pushAssistant("⚠️ Sorry, I didn’t understand that question format.");
          return;
        }
        shape.siteId = customerName
        shape.tenantId = customerName
        if (!shape?.metric) {
          shape.metric = '*'
          shape.render_spec = { sections: ["header", "kpi_utilization", "kpi_part_count", "kpi_downtime", "downtime_reasons"] }
        }

      } catch (e) {
        // Fall back to simple fetch if LLM unavailable
      }

      //setup the render spec to default then modify for specific intent and metric request
      shape.render_spec = { sections: ["header", "kpi_utilization", "kpi_uptime", "kpi_downtime", "all_uptime"] }
      if (shape?.intent === "machine_state") {
        shape.render_spec = { sections: ["header", "machine_state"] }
      } else if (shape?.intent === "summary" && shape?.metric === "part_count_total") {
        shape.render_spec = { sections: ["header", "kpi_part_count", "all_part_producers"] }
      }
      else if (shape?.intent === "summary" && shape?.metric === "utilization_pct") {
        shape.render_spec = { sections: ["header", "kpi_utilization", "all_utilization"] }
      }
      else if (shape?.intent === "summary" && shape?.metric === "downtime_hours_total") {
        shape.render_spec = { sections: ["header", "kpi_downtime", "downtime_reasons", "all_downtime"] }
      }
      else if (shape?.intent === "summary" && shape?.metric === "downtime_hours_avg") {
        shape.render_spec = { sections: ["header", "kpi_downtime", "downtime_reasons", "all_downtime_avg"] }
      }
      else if (shape?.intent === "summary" && shape?.metric === "uptime_hours_total") {
        shape.render_spec = { sections: ["header", "kpi_uptime", "all_uptime"] }
      }
      else if (shape?.intent === "summary" && shape?.metric === "uptime_hours_avg") {
        shape.render_spec = { sections: ["header", "all_uptime_avg"] }
      }
      else if (shape?.intent === "compare" && shape?.metric === "uptime_hours_total") {
        shape.render_spec = { sections: ["header", "kpi_uptime", "all_uptime"] }
      }


      if (shape?.useCurrentShift) {
        const siteId = customerName; // or from your dashboard context
        data = await fetchCurrentShiftSummary({ siteId, downtimePath });
        if (shape?.intent === "machine_state") {
          const rows = Array.isArray(data.by_machine) ? data.by_machine : [];
          const id = (shape.machineId || "").trim().toLowerCase();
          if (id === "" || id === "all" || id === "*") {
            answer = summarizeMachineStatusList(data, question, shape);
          }
          else {
            const row = rows.find(r => (r.machineId || "").toLowerCase() === shape.machineId.toLowerCase());

            if (!row) {
              answer = `I couldn’t find a machine named "${id}" in the current shift.`;

            }
            else {
              answer = summarizeMachineStateRow(row);
            }
          }
        }
        //Testing out using LLM to summarize Current Shift data in hopes all the code
        //above this can go away
        const fallback = answer
        if (shape?.intent === "machine_state") {
          answer = await narrateOrFallback(shape.intent, shape, compactMachineState(data, shape), fallback);

        }
        else {
          //answer = await narrateOrFallback(shape.intent, shape, compactSingle(data), fallback);
          answer = await narrateOrFallback(shape.intent, shape, compactSingle(data, shape), fallback);
        }

      } else {

        // Fetch each range in parallel
        const ranges = Array.isArray(shape?.ranges) ? shape.ranges : [];
        if (ranges.length === 0) {
          answer = "I couldn’t determine a time window for that request.";
        }
        else if (ranges.length === 1) {
          // Single range: simple summary
          data = await fetchShiftSummary({ shiftName: shape.shiftName, dateStart: ranges[0].dateStart, dateEnd: ranges[0].dateEnd, siteId: customerName, tenantId: customerName });
          //maybe the machineId filter failed
          const fallback = summarizeResponse(data, question, mode);
          const compact = compactSingle(data, shape)
          if (compact.by_machine.length == 0 && shape.machineId != "") {
            answer = `I couldn’t find a machine named "${shape.machineId}" in the current shift.`;
          }

          else {
            answer = await narrateOrFallback(shape.intent, shape, compact, fallback);
          }
        }
        else {
          const requests = ranges.map(r =>
            fetchShiftSummary({
              siteId: customerName,
              tenantId: customerName,
              shiftName: r.shiftName ? r.shiftName : shape.shiftName, //we are adding the shiftName to each range in case it's diff. than the overall shape.shiftName
              dateStart: r.dateStart,
              dateEnd: r.dateEnd,
              options: { includeMachines: true }
            })
          );
          const results = await Promise.all(requests);

          // Compact all the windows into one payload
          const compacted = compactMultiSummaries(results, shape);

          if (compacted.windows[0].top.length == 0) {
            answer = `I couldn’t find a machine named "${shape.intent_detail.machineId}" in the current shift.`;
          }
          else {
            // TODO (next step): pass `results` + `shape` into a formatter that understands
            // sequential (6 weeks), pairwise (WoW/MoM/ QoQ), etc.
            // For now, show each window with summarizeResponse:
            const blocks = results.map((data, i) => `Window ${i + 1} — ${shape.granularity || "period"}:
          ${summarizeResponse(data, question, /downtime|unlabeled/i.test(question) ? "downtime" : "general")}`);
            const fallback = blocks.join("\n\n");
            shape.style = { bullets: true, emoji: true, max_words: results.length * 30, period_breakdown: "all" }//make the summary longer for multiple windows
            answer = await narrateOrFallback(shape.intent, shape, compacted, fallback, "multi");
          }

        }
      }
      if (!answer) {
        answer = summarizeResponse(data, question, mode);
      }
      pushAssistant(answer);
      return;
    } catch (err) {
      console.error(err);
      pushAssistant("Sorry, I couldn’t fetch that right now.");
      setToast("Network error or API unavailable.");
    } finally {
      setLoading(false);
      if (toast) setTimeout(() => setToast(null), 2200);
    }
  }




  async function narrateOrFallback(intent, shape, payload, fallbackText, mode = "single") {
    try {
      const text = await getNarrativeFromLLM({ intent, shape, payload, mode });
      if (text && text.trim()) return "📅 " + text;
    } catch (e) {
      console.warn("Summarize LLM failed:", e);
    }
    return fallbackText; // your existing summarize*() output
  }


  return (
    <>
      <button
        onClick={() => setOpen(o => !o)}
        title="Machine Assistant"
        style={{
          position: "fixed", right: 16, bottom: 16, width: 56, height: 56,
          borderRadius: "50%", background: "#111827", color: "white",
          display: "flex", alignItems: "center", justifyContent: "center",
          cursor: "pointer", zIndex: 1000
        }}
      >
        🤖
      </button>
      <ChatPanel
        isOpen={open}
        onClose={() => setOpen(false)}
        messages={messages}
        loading={loading}
        onAsk={handleAsk}
      />
      <Toast show={!!toast} text={toast || ""} />
    </>
  );
}
